/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutrition-plan-ip.reducer';

export const NutritionPlanIPDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutritionPlanIPEntity = useAppSelector(state => state.nutritionPlanIP.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutritionPlanIPDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.detail.title">NutritionPlanIP</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.id}</dd>
          <dt>
            <span id="planName">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.planName">Plan Name</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.planName}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.description">Description</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.description}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.type">Type</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.type}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.active">Active</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanIPEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionPlanIP.hospital">Hospital</Translate>
          </dt>
          <dd>{nutritionPlanIPEntity.hospital ? nutritionPlanIPEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nutrition-plan-ip" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutrition-plan-ip/${nutritionPlanIPEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutritionPlanIPDetail;
